module.exports = __webpack_public_path__ + "img/bg_prev_popup.0feb7df6.png";